"use strict";
/*
 * HSInputNumber
 * @version: 2.5.1
 * @author: Preline Labs Ltd.
 * @license: Licensed under MIT and Preline UI Fair Use License (https://preline.co/docs/license.html)
 * Copyright 2024 Preline Labs Ltd.
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var utils_1 = require("../../utils");
var base_plugin_1 = __importDefault(require("../base-plugin"));
var HSInputNumber = /** @class */ (function (_super) {
    __extends(HSInputNumber, _super);
    function HSInputNumber(el, options) {
        var _this = _super.call(this, el, options) || this;
        _this.input = _this.el.querySelector('[data-hs-input-number-input]') || null;
        _this.increment =
            _this.el.querySelector('[data-hs-input-number-increment]') || null;
        _this.decrement =
            _this.el.querySelector('[data-hs-input-number-decrement]') || null;
        if (_this.input)
            _this.checkIsNumberAndConvert();
        var data = _this.el.dataset.hsInputNumber;
        var dataOptions = data
            ? JSON.parse(data)
            : { step: 1 };
        var concatOptions = __assign(__assign({}, dataOptions), options);
        _this.minInputValue = 'min' in concatOptions ? concatOptions.min : 0;
        _this.maxInputValue = 'max' in concatOptions ? concatOptions.max : null;
        _this.step =
            'step' in concatOptions && concatOptions.step > 0
                ? concatOptions.step
                : 1;
        _this.init();
        return _this;
    }
    HSInputNumber.prototype.init = function () {
        this.createCollection(window.$hsInputNumberCollection, this);
        if (this.input && this.increment)
            this.build();
    };
    HSInputNumber.prototype.checkIsNumberAndConvert = function () {
        var value = this.input.value.trim();
        var cleanedValue = this.cleanAndExtractNumber(value);
        if (cleanedValue !== null) {
            this.inputValue = cleanedValue;
            this.input.value = cleanedValue.toString();
        }
        else {
            this.inputValue = 0;
            this.input.value = '0';
        }
    };
    HSInputNumber.prototype.cleanAndExtractNumber = function (value) {
        var cleanedArray = [];
        var decimalFound = false;
        value.split('').forEach(function (char) {
            if (char >= '0' && char <= '9')
                cleanedArray.push(char);
            else if (char === '.' && !decimalFound) {
                cleanedArray.push(char);
                decimalFound = true;
            }
        });
        var cleanedValue = cleanedArray.join('');
        var number = parseFloat(cleanedValue);
        return isNaN(number) ? null : number;
    };
    HSInputNumber.prototype.build = function () {
        if (this.input)
            this.buildInput();
        if (this.increment)
            this.buildIncrement();
        if (this.decrement)
            this.buildDecrement();
        if (this.inputValue <= 0 && this.minInputValue === 0) {
            this.inputValue = 0;
            this.input.value = '0';
        }
        if (this.inputValue <= 0 || this.minInputValue < 0)
            this.changeValue();
        if (this.input.hasAttribute('disabled'))
            this.disableButtons();
    };
    HSInputNumber.prototype.buildInput = function () {
        var _this = this;
        this.input.addEventListener('input', function () { return _this.changeValue(); });
    };
    HSInputNumber.prototype.buildIncrement = function () {
        var _this = this;
        this.increment.addEventListener('click', function () {
            _this.changeValue('increment');
        });
    };
    HSInputNumber.prototype.buildDecrement = function () {
        var _this = this;
        this.decrement.addEventListener('click', function () {
            _this.changeValue('decrement');
        });
    };
    HSInputNumber.prototype.changeValue = function (event) {
        var _a, _b;
        if (event === void 0) { event = 'none'; }
        var payload = { inputValue: this.inputValue };
        var minInputValue = (_a = this.minInputValue) !== null && _a !== void 0 ? _a : Number.MIN_SAFE_INTEGER;
        var maxInputValue = (_b = this.maxInputValue) !== null && _b !== void 0 ? _b : Number.MAX_SAFE_INTEGER;
        this.inputValue = isNaN(this.inputValue) ? 0 : this.inputValue;
        switch (event) {
            case 'increment':
                var incrementedResult = this.inputValue + this.step;
                this.inputValue =
                    incrementedResult >= minInputValue &&
                        incrementedResult <= maxInputValue
                        ? incrementedResult
                        : maxInputValue;
                this.input.value = this.inputValue.toString();
                break;
            case 'decrement':
                var decrementedResult = this.inputValue - this.step;
                this.inputValue =
                    decrementedResult >= minInputValue &&
                        decrementedResult <= maxInputValue
                        ? decrementedResult
                        : minInputValue;
                this.input.value = this.inputValue.toString();
                break;
            default:
                var defaultResult = isNaN(parseInt(this.input.value))
                    ? 0
                    : parseInt(this.input.value);
                this.inputValue =
                    defaultResult >= maxInputValue
                        ? maxInputValue
                        : defaultResult <= minInputValue
                            ? minInputValue
                            : defaultResult;
                if (this.inputValue <= minInputValue)
                    this.input.value = this.inputValue.toString();
                break;
        }
        payload.inputValue = this.inputValue;
        if (this.inputValue === minInputValue) {
            this.el.classList.add('disabled');
            if (this.decrement)
                this.disableButtons('decrement');
        }
        else {
            this.el.classList.remove('disabled');
            if (this.decrement)
                this.enableButtons('decrement');
        }
        if (this.inputValue === maxInputValue) {
            this.el.classList.add('disabled');
            if (this.increment)
                this.disableButtons('increment');
        }
        else {
            this.el.classList.remove('disabled');
            if (this.increment)
                this.enableButtons('increment');
        }
        this.fireEvent('change', payload);
        (0, utils_1.dispatch)('change.hs.inputNumber', this.el, payload);
    };
    HSInputNumber.prototype.disableButtons = function (mode) {
        if (mode === void 0) { mode = 'all'; }
        if (mode === 'all') {
            if (this.increment.tagName === 'BUTTON' ||
                this.increment.tagName === 'INPUT')
                this.increment.setAttribute('disabled', 'disabled');
            if (this.decrement.tagName === 'BUTTON' ||
                this.decrement.tagName === 'INPUT')
                this.decrement.setAttribute('disabled', 'disabled');
        }
        else if (mode === 'increment') {
            if (this.increment.tagName === 'BUTTON' ||
                this.increment.tagName === 'INPUT')
                this.increment.setAttribute('disabled', 'disabled');
        }
        else if (mode === 'decrement') {
            if (this.decrement.tagName === 'BUTTON' ||
                this.decrement.tagName === 'INPUT')
                this.decrement.setAttribute('disabled', 'disabled');
        }
    };
    HSInputNumber.prototype.enableButtons = function (mode) {
        if (mode === void 0) { mode = 'all'; }
        if (mode === 'all') {
            if (this.increment.tagName === 'BUTTON' ||
                this.increment.tagName === 'INPUT')
                this.increment.removeAttribute('disabled');
            if (this.decrement.tagName === 'BUTTON' ||
                this.decrement.tagName === 'INPUT')
                this.decrement.removeAttribute('disabled');
        }
        else if (mode === 'increment') {
            if (this.increment.tagName === 'BUTTON' ||
                this.increment.tagName === 'INPUT')
                this.increment.removeAttribute('disabled');
        }
        else if (mode === 'decrement') {
            if (this.decrement.tagName === 'BUTTON' ||
                this.decrement.tagName === 'INPUT')
                this.decrement.removeAttribute('disabled');
        }
    };
    // Global method
    HSInputNumber.getInstance = function (target, isInstance) {
        var elInCollection = window.$hsInputNumberCollection.find(function (el) {
            return el.element.el ===
                (typeof target === 'string' ? document.querySelector(target) : target);
        });
        return elInCollection
            ? isInstance
                ? elInCollection
                : elInCollection.element
            : null;
    };
    HSInputNumber.autoInit = function () {
        if (!window.$hsInputNumberCollection)
            window.$hsInputNumberCollection = [];
        document
            .querySelectorAll('[data-hs-input-number]:not(.--prevent-on-load-init)')
            .forEach(function (el) {
            if (!window.$hsInputNumberCollection.find(function (elC) { var _a; return ((_a = elC === null || elC === void 0 ? void 0 : elC.element) === null || _a === void 0 ? void 0 : _a.el) === el; }))
                new HSInputNumber(el);
        });
    };
    return HSInputNumber;
}(base_plugin_1.default));
window.addEventListener('load', function () {
    HSInputNumber.autoInit();
    // Uncomment for debug
    // console.log('Input number collection:', window.$hsInputNumberCollection);
});
if (typeof window !== 'undefined') {
    window.HSInputNumber = HSInputNumber;
}
exports.default = HSInputNumber;
